import React from 'react';
import { RoiCategoriesConfigSection } from '../uis/RoiCategoriesConfigSection';
import styles from '../ProjectEditForm.module.css';

/**
 * Project-level ROI types and enablement (stored on annotationUI.config.roi).
 * Shown after Items; hidden body when the selected UI does not support ROI overlays.
 */
function RoiSettingsPanel({
    supportsRoi,
    annotationUI,
    setAnnotationUI,
    projectChrome,
    settingsLocked = false,
}) {
    const roi = annotationUI?.config?.roi ?? { enabled: false, roiCategories: [] };

    if (!supportsRoi) {
        return (
            <section
                id="project-section-roi"
                className={styles.settingsScrollAnchor}
                aria-label="Regions of interest"
            >
                <div className={styles.panel}>
                    <h4 className={styles.panelTitle}>Regions of interest (project)</h4>
                    <p className={styles.persistenceNote}>
                        Not available for this UI.
                    </p>
                </div>
            </section>
        );
    }

    return (
        <section
            id="project-section-roi"
            className={styles.settingsScrollAnchor}
            aria-label="Regions of interest"
        >
            <div className={styles.panel}>
                <h4 className={styles.panelTitle}>Regions of interest (project)</h4>
                {settingsLocked && (
                    <p className={styles.panelLockBanner}>
                        Published: return to draft to edit this section.
                    </p>
                )}
                <div className={settingsLocked ? styles.panelDisabled : undefined}>
                    <RoiCategoriesConfigSection
                        roi={roi}
                        showIntro={false}
                        onRoiChange={(nextRoi) => {
                            setAnnotationUI((prev) => ({
                                ...prev,
                                config: { ...(prev.config ?? {}), roi: nextRoi },
                            }));
                        }}
                        roiEditorChrome={projectChrome}
                    />
                </div>
            </div>
        </section>
    );
}

export default React.memo(RoiSettingsPanel);
